import React from 'react';
import { ShieldCheckIcon, LockIcon, ZapIcon } from 'lucide-react';
import { SectionWrapper, FadeIn, CTAButton } from './Shared';
export const Guarantee = () => {
  return <SectionWrapper className="bg-white" data-id="element-58">
      <div className="max-w-3xl mx-auto bg-sage-50 rounded-2xl md:rounded-3xl p-6 md:p-12 border border-sage-100 text-center" data-id="element-59">
        <FadeIn data-id="element-60">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full shadow-sm mb-6" data-id="element-61">
            <ShieldCheckIcon className="w-10 h-10 text-sage-600" data-id="element-62" />
          </div>

          <h2 className="text-3xl font-bold text-sage-900 mb-6" data-id="element-63">
            🔒 Garantía total
          </h2>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mb-8" data-id="element-64">
            <div className="flex items-center gap-2 text-slate-700 font-medium" data-id="element-65">
              <LockIcon className="w-5 h-5 text-sage-500" data-id="element-66" />
              <span data-id="element-67">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2 text-slate-700 font-medium" data-id="element-68">
              <ZapIcon className="w-5 h-5 text-sage-500" data-id="element-69" />
              <span data-id="element-70">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-2 text-slate-700 font-medium" data-id="element-71">
              <ShieldCheckIcon className="w-5 h-5 text-sage-500" data-id="element-72" />
              <span data-id="element-73">Garantía de 7 días</span>
            </div>
          </div>

          <p className="text-lg text-slate-600 mb-8 max-w-lg mx-auto" data-id="element-74">
            Si no te sirve, te devolvemos el dinero. Tenés 7 días para probar
            todo el material sin riesgo.
          </p>

          <CTAButton data-id="element-75">👉 Acceder ahora</CTAButton>
        </FadeIn>
      </div>
    </SectionWrapper>;
};